export default __webpack_public_path__ + "static/media/icon-instagram.059fc7cb.svg";